import React, { useEffect, useState } from 'react';
import "./ThemeToggle.css";

const ThemeToggle = () => {
    const [theme, setTheme] = useState(() => {
        // Get from localStorage or use system preference
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme) {
            return savedTheme;
        }
        
        // Check system preference
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }
        
        return 'light';
    });
    
    const [isAnimating, setIsAnimating] = useState(false);

    const toggleTheme = () => {
        setIsAnimating(true);
        setTimeout(() => {
            setTheme(theme === 'light' ? 'dark' : 'light');
        }, 300);
    };

    useEffect(() => {
        document.body.className = theme;
        localStorage.setItem('theme', theme);
        
        // Listen for system theme changes
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            if (!localStorage.getItem('theme')) {
                setTheme(e.matches ? 'dark' : 'light');
            }
        };
        
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', handleChange);
            return () => mediaQuery.removeEventListener('change', handleChange);
        } else {
            // Fallback for older browsers
            mediaQuery.addListener(handleChange);
            return () => mediaQuery.removeListener(handleChange);
        }
    }, [theme]);
    
    useEffect(() => {
        if (isAnimating) {
            const timer = setTimeout(() => setIsAnimating(false), 600);
            return () => clearTimeout(timer);
        }
    }, [isAnimating]);

    return (
        <div className="theme__toggle">
            <button 
                onClick={toggleTheme} 
                className={`theme__button ${isAnimating ? 'theme__button--animating' : ''}`}
                aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
            >
                <div className="theme__icon-container">
                    <span className={`theme__icon ${theme === 'light' ? 'theme__icon--moon' : 'theme__icon--sun'}`}>
                        {theme === 'light' ? '🌙' : '☀️'}
                    </span>
                </div>
            </button>
        </div>
    );
};

export default ThemeToggle;